<template>
  <div class="case-detail-region-quality-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ $t('DIALOG.caseDetailRegionQuality.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="data-container col-block">
      <div class="data-title-container row-block">
        <div
          class="data-title"
          v-html="[
            regionData.region_classification,
            regionData.SV_type,
            [
              'chr' + regionData.SV_chrom,
              regionData.CytoBand
            ].map(v => '(' + v + ')').join('')
          ].join(' ')"
        ></div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block flex-start width-full">
        <div class="data-content-block col-block">
          <div class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOption['default']" :key="oindex" :class="[option.position, { hidden: !option.title }]" :style="{ flex: option.flex }">
              <div :style="{ flex: 1 }"></div>
              <div class="data-content" v-html="option.title"></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
          <div v-for="(qualityData, qdindex) in qualityDatas" :key="qdindex" class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOption['default']" :key="oindex" :class="[option.position, { hidden: !option.title }]" :style="{ flex: option.flex, width: 0 }">
              <div v-if="option.value === 'genotype' && qualityData.GT !== undefined" class="data-content quality-col genotype-container col-block" :class="{ alert: false }">
                <div class="quality-value-block row-block">
                  <div class="quality-value">{{ qualityData.GT_raw || qualityData.GT || 'N/A' }}</div>
                </div>
              </div>
              <div v-else-if="option.value === 'genotypeQuality' && ![null, undefined].includes(qualityData.GQ)" class="data-content quality-col genotypeQuality-container col-block" :class="{ alert: option.info && (qualityData.GQ || 0) < 20 }">
                <div class="quality-value-block row-block">
                  <div class="quality-value">{{ qualityData.GQ || 0 }}</div>
                </div>
                <template v-if="option.info">
                  <div :style="{ height: '0px' }"></div>
                  <div class="pass-info-block row-block">
                    <img :src="require('../../assets/images/quality-' + ((qualityData.GQ || 0) < 15 ? 'nopass' : 'pass') + '-info-icon.svg')" alt="" :style="{ width: '16px' }">
                    <div :style="{ width: '5px' }"></div>
                    <div class="pass-info" v-html="(qualityData.GQ || 0) < 15 ? $t('DIALOG.caseDetailRegionQuality.pass.genotypeQuality.___noPass') : $t('DIALOG.caseDetailRegionQuality.pass.genotypeQuality.___pass')"></div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </template>
              </div>
              <div v-else class="data-content" :class="[option.break ? 'break-line' : 'ellipsis']" :title="qualityData[option.value]" :style="{ color: (option.color || (() => null))(qualityData[option.value], qualityData), 'max-height': option.maxHeight || 'auto' }" v-html="(option.display || (x => x))(qualityData[option.value], qualityData) || option.empty || '- -'"></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
      </div>
      <div :style="{ height: '20px' }"></div>
      <div class="data-title-container row-block">
        <div class="data-title">{{ $t('DIALOG.caseDetailRegionQuality.___infoTitle') }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block flex-start width-full">
        <div class="data-content-block col-block">
          <div class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOption['info1']" :key="oindex" :class="[option.position, { hidden: !option.title }]" :style="{ flex: option.flex }">
              <div :style="{ flex: 1 }"></div>
              <div class="data-content" v-html="option.title"></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
          <div v-for="(qualityData, qdindex) in qualityDatas" :key="qdindex" class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOption['info1']" :key="oindex" :class="[option.position, { hidden: !option.title }]" :style="{ flex: option.flex, width: 0 }">
              <div class="data-content" :class="[option.break ? 'break-line' : 'ellipsis']" :title="qualityData[option.value]" :style="{ color: (option.color || (() => null))(qualityData[option.value], qualityData), 'max-height': option.maxHeight || 'auto' }" v-html="(option.display || (x => x))(qualityData[option.value], qualityData) || option.empty || '- -'"></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="data-content-container col-block flex-start width-full">
        <div class="data-content-block col-block">
          <div class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOption['info2']" :key="oindex" :class="[option.position, { hidden: !option.title }]" :style="{ flex: option.flex }">
              <div :style="{ flex: 1 }"></div>
              <div class="data-content" v-html="option.title"></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
          <div v-for="(qualityData, qdindex) in qualityDatas" :key="qdindex" class="data-row row-block stretch">
            <div class="data-col col-block" v-for="(option, oindex) in tableOption['info2']" :key="oindex" :class="[option.position, { hidden: !option.title }]" :style="{ flex: option.flex, width: 0 }">
              <div class="data-content" :class="[option.break ? 'break-line' : 'ellipsis']" :title="qualityData[option.value]" :style="{ color: (option.color || (() => null))(qualityData[option.value], qualityData), 'max-height': option.maxHeight || 'auto' }" v-html="(option.display || (x => x))(qualityData[option.value], qualityData) || option.empty || '- -'"></div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { defaultEmptyDisplay } from '../../constants/global/data'

export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    qualityDatas () {
      return [this.param.regionData]
    },
    // static
    tableOption () {
      const defaultOptions = [
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___genotype'),
          value: 'GT',
          color: null,
          flex: 1,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___filter'),
          value: 'FT',
          color: value => value && value !== 'PASS' ? 'FA3D3D' : '#333333',
          flex: 1,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___genotypeQuality'),
          value: 'genotypeQuality',
          color: null,
          flex: 2,
          info: true,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___phredScaled'),
          value: 'PL',
          color: null,
          flex: 2,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___PairedRead'),
          value: 'PR',
          color: null,
          flex: 1,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.default.title.___SplitRead'),
          value: 'SR',
          color: null,
          flex: 1,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        }
      ]
      const info1Options = [
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___IMPRECISE'),
          value: 'IMPRECISE',
          color: null,
          flex: 1,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___Confidence'),
          value: 'CIPOS',
          color: null,
          flex: 2,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___SV_Length'),
          value: 'SVINSLEN',
          color: null,
          flex: 1,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___BF'),
          value: 'BF',
          color: null,
          flex: 1,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___RATIO'),
          value: 'RATIO',
          color: null,
          flex: 1,
          position: 'center',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          flex: 2
        }
      ]
      const info2Options = [
        {
          title: this.$t('DIALOG.caseDetailRegionQuality.table.info.title.___SV_Sequence'),
          value: 'SVINSSEQ',
          color: null,
          flex: 1,
          position: 'center',
          break: true,
          maxHeight: '200px',
          empty: this.$t(defaultEmptyDisplay.empty)
        },
        {
          flex: 1
        }
      ]
      return {
        default: defaultOptions,
        info1: info1Options,
        info2: info2Options
      }
    },
    // param
    regionData () {
      return this.param.regionData
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailRegionQuality.vue